import { typography } from './typography'
import { palette } from './palette'

export const theme = { typography, palette }
